export const scammerReferenceData = {
  telephone: {
    title: 'Please enter the number',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/a57448822385-tooliconphonenumber.jpg',
    },
  },
  online: {
    title: 'Please enter the link to the website',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/9b12277746a7-tool-icon-website.jpg',
    },
  },
  email: {
    title: 'Please enter the email address the email was sent from',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/ca6d176c1944-tool-icon-web-question.jpg',
    },
  },
  textMessage: {
    title: 'Please enter the number the text came from',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/a57448822385-tooliconphonenumber.jpg',
    },
  },
  whatsapp: {
    title: 'Please enter the number the WhatsApp came from',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/a57448822385-tooliconphonenumber.jpg',
    },
  },
  social: {
    title: 'Please enter the website address',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/9b12277746a7-tool-icon-website.jpg',
    },
  },
}
